import { render, staticRenderFns } from "./McPager.vue?vue&type=template&id=42aba9f4&"
import script from "./McPager.vue?vue&type=script&lang=js&"
export * from "./McPager.vue?vue&type=script&lang=js&"
import style0 from "./McPager.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "McPager.vue"
export default component.exports